// Auto-generated skeleton for Invoice

import { VendorAccount } from "./VendorAccount";
import { AccountingYear } from "./AccountingYear";
import { Building } from "./Building";
import { CraftsmanTask } from "./CraftsmanTask";
import { DocumentContainer } from "./DocumentContainer";
import { Team } from "./Team";
import { Account } from "./Account";

export const Invoice: Api.Invoice = {
  id: 0,
  invoice_number: '',
  hp_id: null,
  invoice_id: 0,
  invoice_date: '',
  date_received: null,
  invoice_amount: 0,
  recognized_amount: 0,
  authorized_date: null,
  authorized_amount: 0,
  due_date: null,
  intended_use: null,
  booking_text: null,
  comments_count: 0,
  vendor_account: VendorAccount,
  vendor_account_id: 0,
  accounting_year: AccountingYear,
  accounting_year_id: 0,
  building: Building,
  building_id: 0,
  craftsman_task: CraftsmanTask,
  craftsman_task_id: 0,
  document_container: DocumentContainer,
  document_container_id: 0,
  created_team: Team,
  created_team_id: 0,
  booking_account: Account,
  booking_account_id: 0,
  paid_via_account: Account,
  paid_via_account_id: 0,
  comments: [],
  created: null,
  updated: null,
};

